/**
 * 模块名称: 招聘模块 -> 招聘申请
 * @author zhuyan@372163.com
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  InputNumber,
  Select,
  message,
  DatePicker,
  Radio,
  Upload,
  Icon,
  Button,
  Row,
  Col,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { uploadDragger } from '@/utils/uploadDragger'
import { allTrim, filterParams, uniqueByName } from '@/utils'
import { jobTypeList, expYearList } from '@/utils/constant'
import moment from 'moment'

const FormItem = Form.Item
const Option = Select.Option
const { Dragger } = Upload
const dateFormat = 'YYYY-MM-DD'

let draggerObj = {}

const Addrecruit = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue, getFieldValue } = props.form
  const { setEditVisible, getList, setformLoading, editId } = props
  const [saveLoading, setSaveLoading] = useState(false)
  const [reasonList, setReasonList] = useState([])
  const [educationList, setEducationList] = useState([])
  const [reasonType, setReasonType] = useState('')
  const [jobPostFileType, setJobPostFileType] = useState(1)
  const [jobType, setJobType] = useState('')
  const [leaveStaffList, setLeaveStaffList] = useState([])
  const [groupList, setGroupList] = useState([])//获取事业群
  const [departmentList, setDepartmentList] = useState([])//获取部门
  const [projectList, setProjectList] = useState([])
  const [jobPostList, setJobPostList] = useState([])
  const [jobPostFileList, setJobPostFileList] = useState([])
  const [leaveDateDisabled, setLeaveDateDisabled] = useState(false)

  useEffect(() => {
    getSearchData()
    draggerObj = uploadDragger({
      accept: '.pdf',
      limitNum: 1,
      limitSize: 5,
    })
    api.getUser().then(data => {
      const { groupId, departmentId, id } = data
      api.getJobPostFileGroupUserList({ 
        userId: id 
      }).then(list => {
        setJobPostFileList(list)
      })
      if (editId) {
        getDetail()
      } else {
        setFieldsValue({
          groupId,
        })
        getDepartMentList(groupId, departmentId)
      }
    }).catch(err => console.log(err))
  }, [])

  useEffect(() => {
    if (reasonType && !editId) {
      switch (reasonType) {
        case 1:
          setFieldsValue({
            jobPostFileIsNew: 1,
            applyRecruitNum: '',
          })
          setJobPostFileType(1)
          break
        case 5:
          setFieldsValue({
            jobPostFileIsNew: 2,
            applyRecruitNum: 1,
          })
          setJobPostFileType(2)
          break
        case 6:
          setFieldsValue({
            jobPostFileIsNew: 2,
            applyRecruitNum: '',
          })
          setJobPostFileType(2)
          break
      }
    }
  }, [reasonType])

  const getDetail = () => { 
    api.getStaffRecruitmentInfo({ 
      id: editId 
    }).then(res => {
      const { 
        recruitReason,
        treatment, 
        jobPostFileIsNew, 
        fileInfo, 
        fileName, 
        name, 
        jobPostFileId,
        groupId, 
        departmentId, 
        jobType, 
        projectId, 
        applyRecruitNum,
        expYear,
        arrivalDate,
        age,
        educationLevel,
        major,
        jobRequirements,
        jobReq
      } = res
      let treatmentArr = []
      if (treatment) {
        treatmentArr = treatment.split('~')
      }
      setJobType(jobType)
      setReasonType(recruitReason)
      setJobPostFileType(jobPostFileIsNew)
      setFieldsValue({
        recruitReason,
        jobPostFileIsNew,
        jobType,
        applyRecruitNum,
        expYear: Number(expYear),
        groupId, 
        treatmentStart: treatment ? treatmentArr[0] : '',
        treatmentEnd: treatment ? treatmentArr[1] : '',
        arrivalDate: arrivalDate ? moment(arrivalDate) : null,
        age: age ? age : '',
        educationLevel: educationLevel ? educationLevel : '',
        major: major ? major : '',
        jobRequirements: jobRequirements ? jobRequirements : '',
        jobReq: jobReq ? jobReq : ''
      })
      getDepartMentList(groupId, departmentId)
      if (jobPostFileIsNew === 1) {
        setFieldsValue({
          fileInfo: [{
            uid: '-1',
            name: fileInfo.name,
            status: 'done',
            url: fileInfo.url,
          }],
          fileName,
          name,
        })
      } else {
        setFieldsValue({
          jobPostFileId,
        })
        api.getJobPostList({ 
          limit: global.paramsLimit,
          jobPostFileId,
        }).then(res => {
          setJobPostList(uniqueByName(res.list))
          setFieldsValue({
            name,
          })
        }).catch(err => console.log(err))
      }
      if (projectId) {
        setFieldsValue({
          projectId: projectId.split(',').map(item => Number(item))
        })
      }
    })
  }

  const getSearchData = () => {
    setformLoading(true)
    Promise.all([
      api.getCommon({ type: 'recruit_reason' }),
      api.getCommon({ type: 'staff_education_level' }),
      api.getsysProjectChilds({ pid: 0 }),
      api.getSelectGroupList({ limit: global.paramsLimit }),
    ]).then(data => {
      setformLoading(false)
      setReasonList(data[0])
      setEducationList(data[1])
      setProjectList(data[2])
      setGroupList(data[3].list)
    }).catch(() => setformLoading(false))
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  // 保存招聘
  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (editId) {
          vals.id = editId
        }
        if (vals.jobPostFileIsNew === 1) {
          const { url, name } = vals.fileInfo[0]
          vals.fileInfo = { url, name }
        }
        if (vals.treatmentStart) {
          vals.treatment = vals.treatmentStart + '~' + vals.treatmentEnd
        }
        delete vals.treatmentStart
        delete vals.treatmentEnd
        if (vals.projectId) {
          vals.projectId = vals.projectId.join(',')
        }
        if (vals.leaveDate) {
          vals.leaveDate = vals.leaveDate.format(dateFormat)
        }
        if (vals.arrivalDate) {
          vals.arrivalDate = vals.arrivalDate.format(dateFormat)
        }
        setSaveLoading(true)
        api.saveStaffRecruitmentInfo(vals).then(() => {
          setSaveLoading(false)
          setEditVisible(false)
          message.success('添加成功')
          getList()
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  //日期限制
  const disabledDate = (current) => {
    return current && current < moment().subtract(1, "day")
  }

  const onPreviewFile = () => {
    const id = getFieldValue('jobPostFileId')
    if (!id) {
      message.warning('请选择岗位说明书')
      return
    }
    const data = jobPostFileList.find(item => item.id == id)
    window.open(data.fileInfo.url, '_blank')
  }

  const onSearchLeave = value => {
    if (value) {
      api.getLeaveStaffList({
        keyWords: value
      }).then(data => { 
        setLeaveStaffList(data)
      })
    } else {
      setLeaveStaffList([])
    }
  }

  const onSelectLeave = key => {
    const data = leaveStaffList.find(item => item.id === key)
    const { leaveDate, jobPostFileId, jobPostName } = data
    setFieldsValue({
      leaveDate: leaveDate ? moment(leaveDate) : null,
      jobPostFileId: jobPostFileId ? jobPostFileId : undefined,
    })
    setLeaveDateDisabled(!!leaveDate)
    if (jobPostFileId) {
      api.getJobPostList({ 
        limit: global.paramsLimit,
        jobPostFileId,
      }).then(res => {
        setJobPostList(uniqueByName(res.list))
        setFieldsValue({
          name: jobPostName,
        })
      }).catch(err => console.log(err))
    }
  }

  const getDepartMentList = (groupId, departmentId) => {
    api.getSelectDepartmentList({ 
      limit: global.paramsLimit, 
      groupId,
    }).then(res => {
      setDepartmentList(res.list)
      setFieldsValue({
        departmentId,
      })
    }).catch(err => console.log(err))
  }

  const onSelectPostFile = id => {
    api.getJobPostList({ 
      limit: global.paramsLimit,
      jobPostFileId: id,
    }).then(res => {
      setJobPostList(uniqueByName(res.list))
    }).catch(err => console.log(err))
  }

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="增补原因">
          {getFieldDecorator('recruitReason', {
            rules: [{ required: true, message: '请选择增补原因' }]
          })(
            <Select placeholder="请选择" onSelect={key => setReasonType(key)} disabled={!!editId}>
              {reasonList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>
          )}
        </FormItem>
        {reasonType === 5 && (
          <>
            <FormItem label="替补人员">
              {getFieldDecorator('leaveStaffId', {
                rules: [{ required: true, message: '请选择替补人员' }]
              })(
                <Select 
                  placeholder="请选择员工姓名或员工编号"
                  showSearch
                  filterOption={false}
                  onSearch={onSearchLeave}
                  onSelect={onSelectLeave}
                >
                  {leaveStaffList.map(item => <Option key={item.id} value={item.id}>{item.staffName}（{item.staffNo}）</Option>)}
                </Select>
              )}
            </FormItem>
            <FormItem label="替补人员离职日期">
              {getFieldDecorator('leaveDate', {
                rules: [{ required: true, message: '请选择替补人员离职日期' }]
              })(
                <DatePicker 
                  placeholder="请选择替补人员离职日期" 
                  style={{ width: '100%'}}
                  disabled={leaveDateDisabled}
                />
              )}
            </FormItem>
          </>
        )}
        {reasonType !== '' && (
          <>
            <FormItem label="岗位说明书" required>
              {getFieldDecorator('jobPostFileIsNew')(
                <Radio.Group 
                  onChange={evt => setJobPostFileType(evt.target.value)} 
                  disabled={[1, 6].includes(reasonType)}
                >
                <Radio value={2}>选择已有岗位说明书</Radio>
                <Radio value={1}>上传新增岗位说明书</Radio>
              </Radio.Group>)}
            </FormItem>
            {jobPostFileType === 1 ? (
              <>
                <Form.Item wrapperCol={{ span: 18, offset: 6 }}>
                  {getFieldDecorator('fileInfo', {
                    valuePropName: 'fileList',
                    getValueFromEvent: draggerObj.normFile,
                    rules: [{ required: true, message: '请上传岗位说明书' }]
                  })(
                    <Dragger {...draggerObj}>
                      <p className="ant-upload-drag-icon">
                        <Icon type="inbox" />
                      </p>
                      <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                      <p className="ant-upload-hint">
                        支持扩展名：.pdf
                      </p>
                    </Dragger>
                  )}
                </Form.Item>
                <FormItem label="岗位说明书名称">
                  {getFieldDecorator('fileName', {
                    rules: [{ required: true, message: '请输入岗位说明书名称' }]
                  })(
                    <Input placeholder="请输入岗位说明书名称" maxLength={50} />
                  )}
                </FormItem>
                <FormItem label="岗位名称">
                  {getFieldDecorator('name', {
                    rules: [{ required: true, message: '请输入岗位名称' }]
                  })(
                    <Input placeholder="请输入岗位名称" maxLength={50} />
                  )}
                </FormItem>
              </>
            ) : (
              <>
                <FormItem wrapperCol={{ span: 18, offset: 6 }}>
                  <Row gutter={8}>
                    <Col span={16}>
                      {getFieldDecorator('jobPostFileId', {
                        rules: [{ required: true, message: '请选择岗位说明书' }]
                      })(
                        <Select 
                          placeholder="请选择岗位说明书"
                          showSearch
                          optionFilterProp="children"
                          onSelect={onSelectPostFile}
                        >
                          {jobPostFileList.map(item => <Option key={item.id} value={item.id}>{item.fileName}</Option>)}
                        </Select>
                      )}
                    </Col>
                    <Col span={8}>
                      <Button type="primary" onClick={onPreviewFile}>岗位说明书预览</Button>
                    </Col>
                  </Row>
                </FormItem>
                {jobPostList.length > 0 ? (
                  <FormItem label="岗位名称">
                    {getFieldDecorator('name', {
                      rules: [{ required: true, message: '请选择岗位名称' }]
                    })(
                      <Select 
                        placeholder="请选择"
                        showSearch
                        optionFilterProp="children"
                      >
                        {jobPostList.map(item => <Option key={item.id} value={item.name}>{item.name}</Option>)}
                      </Select>
                    )}
                  </FormItem>
                ) : (
                  <FormItem label="岗位名称">
                    {getFieldDecorator('name', {
                      rules: [{ required: true, message: '请输入岗位名称' }]
                    })(
                      <Input placeholder="请输入岗位名称" maxLength={50} />
                    )}
                  </FormItem>
                )}
              </>
            )}
          </>
        )}
        <FormItem label="员工所属事业群">
          {getFieldDecorator('groupId', {
            rules: [{ required: true, message: '请选择员工所属事业群' }]
          })(
            <Select
              placeholder="请选择"
              showSearch
              optionFilterProp="children"
              onSelect={id => getDepartMentList(id, undefined)}
            >
              {groupList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>)}
        </FormItem>
        <FormItem label="员工所属部门">
          {getFieldDecorator('departmentId', {
            rules: [{ required: true, message: '请选择员工所属部门' }]
          })(
            <Select
              placeholder="请选择"
              showSearch
              optionFilterProp="children"
            >
              {departmentList.map(item => <Option key={item.id} value={item.id}>{item.name}（{item.companyName}）</Option>)}
            </Select>)}
        </FormItem>
        <FormItem label="岗位类别">
          {getFieldDecorator('jobType', {
            rules: [{ required: true, message: '请选择岗位类别' }]
          })(
            <Select 
              placeholder="请选择" 
              onSelect={id => setJobType(id)}
            >
              {jobTypeList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>
          )}
        </FormItem>
        {jobType !== 3 && (
          <FormItem label="入职项目">
            {getFieldDecorator('projectId')(
              <Select 
                mode="multiple"
                placeholder="请选择"
                showSearch
                optionFilterProp="children"
              >
                {projectList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
              </Select>
            )}
          </FormItem>
        )}
        <FormItem label="招聘人数">
          {getFieldDecorator('applyRecruitNum', {
            rules: [{ required: true, message: '请输入招聘人数' }]
          })(
            <InputNumber 
              min={1} 
              precision={0}
              placeholder="请输入招聘人数" 
              style={{ width: '100%'}}
              disabled={reasonType === 5}
            />
          )}
        </FormItem>
        <FormItem label="岗位薪资" style={{ marginBottom: 0 }}>
          <FormItem style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}>
            {getFieldDecorator('treatmentStart')(
              <Input placeholder="请输入"/>
            )}
          </FormItem>
          <span style={{ display: 'inline-block', width: '24px', textAlign: 'center' }}>~</span>
          <FormItem style={{ display: 'inline-block', width: 'calc(50% - 12px)' }}>
            {getFieldDecorator('treatmentEnd')(
              <Input placeholder="请输入"/>
            )}
          </FormItem>
        </FormItem>
        <FormItem label="工作经验">
          {getFieldDecorator('expYear', {
            rules: [{ required: true, message: '请选择工作经验' }]
          })(
            <Select placeholder="请选择">
              {expYearList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>
          )}
        </FormItem>
        <FormItem label="希望到岗日期">
          {getFieldDecorator('arrivalDate')(
            <DatePicker placeholder="请选择希望到岗日期" disabledDate={disabledDate} style={{ width: '100%'}}/>
          )}
        </FormItem>
        <FormItem label="年龄">
          {getFieldDecorator('age')(
            <Input placeholder="请输入年龄" />
          )}
        </FormItem>
        <FormItem label="学历">
          {getFieldDecorator('educationLevel')(
            <Select placeholder="请选择学历">
              {educationList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>
          )}
        </FormItem>
        <FormItem label="专业">
          {getFieldDecorator('major')(
            <Input placeholder="请输入专业" />
          )}
        </FormItem>
        <FormItem label="岗位职责">
          {getFieldDecorator('jobRequirements')(
            <Input.TextArea placeholder="请输入岗位职责" />
          )}
        </FormItem>
        <FormItem label="任职资格">
          {getFieldDecorator('jobReq')(
            <Input.TextArea placeholder="请输入任职资格" />
          )}
        </FormItem>
        <BtnGroup onCancel={() => setEditVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  );
}

export default Form.create()(Addrecruit)
